import { MascotLoading } from "./MascotLoading";
import { useEffect, useState, type ReactNode } from "react";
import {
  installedNativeContract,
  watchNativeExternalLinks,
  isNative,
  NATIVE_CONTRACT_VERSION,
} from "./lib/platform";
export function NativeCompatibility({ children }: { children: ReactNode }) {
  const [status, setStatus] = useState<"loading" | "ready" | "error">(
    isNative() ? "loading" : "ready",
  );
  const [linkError, setLinkError] = useState(false);
  useEffect(() => watchNativeExternalLinks(() => setLinkError(true)), []);
  useEffect(() => {
    let active = true;
    if (isNative())
      void installedNativeContract()
        .then((contract) => {
          if (active)
            setStatus(
              contract &&
                contract.version >= NATIVE_CONTRACT_VERSION &&
                contract.origin === window.location.origin
                ? "ready"
                : "error",
            );
        })
        .catch(() => {
          if (active) setStatus("error");
        });
    return () => {
      active = false;
    };
  }, []);
  if (status === "loading")
    return <MascotLoading />;
  if (status === "error")
    return (
      <main className="page">
        <h1>Update Lift &amp; Learn</h1>
        <p>
          This app version cannot open the current experience. Install the
          latest version from your app store.
        </p>
        <button onClick={() => window.location.reload()}>Try again</button>
      </main>
    );
  return <>{linkError && <div className="page" role="alert">Could not open the link. Please try again. <button onClick={() => setLinkError(false)}>Dismiss</button></div>}{children}</>;
}
